import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box } from "@mui/material";
const CustomAvatar = ({ src, onChange, showOnly = false, customStyle = {}, overlayIcon = _jsx(DefaultCameraIcon, {}), }) => {
    const width = customStyle.width || 120;
    const height = customStyle.height || 120;
    return (_jsxs(Box, { sx: {
            position: "relative",
            width,
            height,
            borderRadius: "50%",
            overflow: "hidden",
        }, children: [_jsx(Avatar, { alt: "\u062A\u0635\u0648\u06CC\u0631", src: src, sx: Object.assign({ width: "100%", height: "100%" }, customStyle) }), !showOnly && onChange && (_jsxs(_Fragment, { children: [_jsx("input", { type: "file", accept: "image/*", id: "profile-image-upload", style: { display: "none" }, onChange: (e) => { var _a; return ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) && onChange(e.target.files[0]); } }), _jsx("label", { htmlFor: "profile-image-upload", children: _jsx(Box, { sx: {
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                height: "25%",
                                backdropFilter: "blur(2px)",
                                backgroundColor: "rgba(0, 102, 90, 0.6)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                            }, children: overlayIcon }) })] }))] }));
};
// Default camera icon (inline SVG)
const DefaultCameraIcon = () => (_jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", fill: "white" }), _jsx("path", { d: "M20 4H16.83L15.59 2.65C15.22 2.24 14.68 2 14.12 2H9.88C9.32 2 8.78 2.24 8.4 2.65L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z", fill: "white" })] }));
export default CustomAvatar;
